import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './common/shared.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { CommonModule } from '@angular/common';
import { AuthNGuardService } from './common/services/authn-guard.service';
import { LandingComponent } from './components/landing/landing.component';
import { ApiService } from './common/services/api.service';
import { CanLoadGuard, CanActivateChildGuard } from './common/guards';
import { Rest, AuthZGuard } from './common/services';

const SERVICES = [
    Rest,
    ApiService,
    AuthZGuard,
    CanLoadGuard,
    CanActivateChildGuard
];
@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        SharedModule,
        RouterModule
    ],
    declarations: [
        AppComponent,
        LandingComponent
    ],
    providers: [
        AuthNGuardService,
        ...SERVICES
    ],
    bootstrap: [AppComponent],
    exports: [SharedModule]
})

export class AppModule { }
